export default __webpack_public_path__ + "static/media/doctor.63c11d6a.jpg";